import React, { FC } from "react";
import { AppButton } from "@components/Typography";

interface CtaBlockType {
    textContent: string;
    img: string;
    btntxt?: string;
    customEvent?: string;
}
const CtaBlock: FC<CtaBlockType> = ({ textContent, img, btntxt, customEvent }) => {
    return (
        <section style={{ backgroundColor: "#FFED82" }} className="px-4  py-6 ">
            <div className="flex max-w-6xl  flex-col md:flex-row gap-2 md:gap-0 justify-between md:w-10/12 mx-auto items-center md:pr-6">
                <div className="flex flex-col md:flex-row items-center gap-5 md:w-9/12">
                    <img src={img} alt="bot" style={{ width: "71px" }} />
                    <p className="font-bold md:w-8/12 text-sm md:text-2xl text-center md:text-left" style={{ color: "#2D3748" }}>
                        {textContent}
                    </p>
                </div>
                <div>
                    {customEvent ? (
                        <AppButton buttonText={btntxt ? btntxt : "Start Free Trial"} href={customEvent} />
                    ) : (
                        <AppButton buttonText={btntxt ? btntxt : "Start Free Trial"} href="https://app.gallabox.com/signup" />
                    )}
                </div>
            </div>
        </section>
    );
};

export default CtaBlock;
